import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

import { MaterialVisitorAccordion } from '../../../business/visitor/material-visitor-accordion';
import { MaterialSoshSignatureDirective } from '../../../directives/material-sosh-signature.directive';

@Component({
    selector: 'ecm-mat-visitor-home-accordions',
    templateUrl: 'material-visitor-home-accordions.html',
    standalone: true,
    imports: [MaterialSoshSignatureDirective, NgbAccordionModule],
})
export class MaterialVisitorHomeAccordionsComponent implements OnInit {
    @Input() public accordions?: MaterialVisitorAccordion[];

    @Input() public e2e?: string;

    @Input() public accordionTitle?: string;

    @Input() public fullWidth?: boolean = false;

    @Output() public visitorButtonClick: EventEmitter<{ zone: string; index: number; href?: string }> =
        new EventEmitter<{
            zone: string;
            index: number;
            href?: string;
        }>();

    /**
     * @inheritDoc
     */
    public ngOnInit(): void {
        // set e2e data tag
        this.e2e = this.e2e || 'e2e-material-visitor-home-accordion-modulo';
    }

    public emitButtonClickEvent(buttonZone: string, buttonIndex: number, href?: string): void {
        this.visitorButtonClick.emit({ zone: buttonZone, index: buttonIndex, href });
    }
}
